export default __webpack_public_path__ + "static/vsco-logo-faac17b9bdf3fc3dd2d9c6a23d6a7cbb.svg";